import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masuri-acces-clinica',
  templateUrl: './masuri-acces-clinica.component.html',
  styleUrls: ['./masuri-acces-clinica.component.scss']
})
export class MasuriAccesClinicaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
